import * as React from "react";

const CheckedIconSVG = (props) => (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24">
        <path
            fill="#16A34A"
            d="M10.137 16 17 9.325 15.637 8l-5.5 5.35-2.774-2.7L6 11.977zM12 22a9.7 9.7 0 0 1-3.9-.788 10.1 10.1 0 0 1-3.175-2.137q-1.35-1.35-2.137-3.175A9.7 9.7 0 0 1 2 12q0-2.075.788-3.9a10.1 10.1 0 0 1 2.137-3.175q1.35-1.35 3.175-2.137A9.7 9.7 0 0 1 12 2q2.075 0 3.9.788a10.1 10.1 0 0 1 3.175 2.137q1.35 1.35 2.137 3.175A9.7 9.7 0 0 1 22 12a9.7 9.7 0 0 1-.788 3.9 10.1 10.1 0 0 1-2.137 3.175q-1.35 1.35-3.175 2.137A9.7 9.7 0 0 1 12 22"
        ></path>
    </svg>
);

export default CheckedIconSVG;
